import { z } from 'zod';
const isPartySlugShaped = (value) => value.split('-').every((segment) => segment.length > 0 && /^[a-z0-9]+$/u.test(segment));
export const ListenIdSchema = z.number().int().positive().brand();
export const ListenerIdSchema = z.number().int().positive().brand();
/** URL-safe party identifier, derived server-side from the DJ-supplied display name. */
export const PartySlugSchema = z
    .string()
    .min(1)
    .max(64)
    .refine(isPartySlugShaped, 'must be a lowercase, hyphen-separated slug')
    .brand();
export const ChannelIdSchema = z.number().int().positive().brand();
/** Server-assigned id for a track once it exists in a queue, history or want list. */
export const TrackIdSchema = z.string().min(1).max(64).brand();
// Two-word passcode a DJ reads out to the room; never exposed on the public party view.
export const PASSKEY_MAX_LENGTH = 32;
export const PasskeySchema = z.string().min(1).max(PASSKEY_MAX_LENGTH).brand();
/** Opaque bearer token proving a device passed the passkey check for one party. */
export const SuggesterTokenSchema = z.string().min(1).max(128).brand();
//# sourceMappingURL=ids.js.map